export const tabs = {
  daily: 1,
  weekly: 2,
  monthly: 3,
  quarterly: 4,
  yearly: 5,
};

export const mapTabTime = {
  [tabs.daily]: 'Daily',
  [tabs.weekly]: 'Weekly',
  [tabs.monthly]: 'Monthly',
  [tabs.quarterly]: 'Quarterly',
  [tabs.yearly]: 'Yearly',
};
